import "core-js/modules/es.array.reverse.js";
var _class;
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import { action, computed, makeObservable } from "mobx";
import DiffableMixin from "../../lib/ModelMixins/DiffableMixin";
import MappableMixin from "../../lib/ModelMixins/MappableMixin";
import CommonStrata from "../../lib/Models/Definition/CommonStrata";
import CreateModel from "../../lib/Models/Definition/CreateModel";
import Terria from "../../lib/Models/Terria";
import mixTraits from "../../lib/Traits/mixTraits";
import CatalogMemberTraits from "../../lib/Traits/TraitsClasses/CatalogMemberTraits";
import DiffableTraits from "../../lib/Traits/TraitsClasses/DiffableTraits";
import SplitterTraits from "../../lib/Traits/TraitsClasses/SplitterTraits";
describe("DiffableMixin", function () {
  describe("canFilterTimeByFeature", function () {
    it("returns false if the item is showing diff", action(function () {
      const testItem = new TestDiffableItem("test", new Terria());
      testItem.setTrait(CommonStrata.user, "isShowingDiff", true);
      expect(testItem.canFilterTimeByFeature).toBe(false);
    }));
    it("otherwise returns the inherited value", action(function () {
      const testItem = new TestDiffableItem("test", new Terria());
      testItem.setTrait(CommonStrata.user, "isShowingDiff", false);
      testItem.setTrait(CommonStrata.user, "timeFilterPropertyName", "foo");
      expect(testItem.canFilterTimeByFeature).toBe(true);
      testItem.setTrait(CommonStrata.user, "timeFilterPropertyName", undefined);
      expect(testItem.canFilterTimeByFeature).toBe(false);
    }));
  });
});
let TestDiffableItem = (_class = class TestDiffableItem extends DiffableMixin(MappableMixin(CreateModel(mixTraits(DiffableTraits, CatalogMemberTraits, SplitterTraits)))) {
  constructor() {
    super(...arguments);
    _defineProperty(this, "styleSelectableDimensions", []);
    makeObservable(this);
  }
  async forceLoadMapItems() {}
  get canDiffImages() {
    return true;
  }
  get discreteTimes() {
    return undefined;
  }
  showDiffImage(_firstDate, _secondDate, _diffStyleId) {}
  clearDiffImage() {}
  getLegendUrlForStyle(_diffStyleId, _firstDate, _secondDate) {
    return "test-legend-url";
  }
  get mapItems() {
    return [];
  }
}, _applyDecoratedDescriptor(_class.prototype, "mapItems", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "mapItems"), _class.prototype), _class);